import ReactEChartsCore from 'echarts-for-react/lib/core';
import { ScatterChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import type { EChartsOption } from 'echarts';
import {
  breakpointsMediaQuery,
  getColor,
  useMediaQuery
} from '@/helpers/utils';
import { Card } from 'react-bootstrap';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { useRef } from 'react';
import CardChartDropDown from '@/components/common/CardChartDropDown';

import { serpTooltips } from '@/app/Serp/tooltip/serpTooltips';
import { useTooltipHide } from '@/hooks/useTooltipHide';
import type { SerpAnalysisDomains } from '@/app/Serp/types/serpApiTypes';
echarts.use([ScatterChart, TooltipComponent, GridComponent, LegendComponent]);

interface DomainRanksWordsProps {
  data: NonNullable<SerpAnalysisDomains['domains_ranks_words']>;
}

// نمودار رتبه کلمات
const DomainRanksWords = ({ data }: DomainRanksWordsProps) => {
  const categories = data.map(item => item.rank);
  const formattedData = data.map(item => ({
    value: item.num_words,
    name: item.domain
  }));

  const cardRef = useRef<HTMLDivElement | null>(null);
  const chartRef = useRef<ReactEChartsCore | null>(null);
  const isMdUp = useMediaQuery(breakpointsMediaQuery.md);
  useTooltipHide(chartRef);
  // تنظیمات نمودار
  const getOption = (): EChartsOption => ({
    grid: { right: '0', left: '10%', bottom: '15%', top: '5%' },
    textStyle: {
      fontFamily: 'dana'
    },
    legend: {
      show: false
    },
    tooltip: {
      triggerOn: isMdUp ? 'mousemove' : 'click',
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      formatter: (params: any) => {
        return `<div style="font-weight:bold;">${params[0].name}</div></br>
        <div>تعداد کلمات: <span style="font-weight:bold;">${params[0].value}</span></div>
        <div>رتبه در گوگل: <span style="font-weight:bold;">${params[0].axisValue}</span></div>
     </div>`.toPersianDigit();
      },
      transitionDuration: 0,
      axisPointer: {
        // type: 'shadow'
      }
    },
    xAxis: {
      //   name: 'تاریخ به‌روزرسانی',
      //   nameLocation: 'center',
      //   nameTextStyle: { color: getColor('gray-900'), padding: 3 },
      data: categories,
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisLabel: {
        show: true,
        color: getColor('gray-800')

        // margin: 5
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: getColor('gray-200')
        }
      }
    },
    yAxis: {
      name: 'تعداد کلمات',
      nameLocation: 'center',
      nameTextStyle: { color: getColor('gray-900'), padding: 24 },
      axisLine: {
        lineStyle: {
          color: getColor('gray-300'),
          type: 'solid'
        }
      },
      axisLabel: {
        show: true,
        color: getColor('gray-800')
        // margin: 5
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: getColor('gray-200')
        }
      }
    },
    series: [
      {
        type: 'line',
        name: 'رتبه و سن',
        data: formattedData,
        lineStyle: {
          color: getColor('navbar-vertical-default-link-active-color')
        },
        itemStyle: {
          color: getColor('navbar-vertical-default-link-active-color')
        },
        showSymbol: true,
        symbol: 'circle',
        smooth: false,
        emphasis: {
          scale: true,
          itemStyle: {
            color: getColor('navbar-vertical-default-link-active-color')
          },
          lineStyle: {
            color: getColor('navbar-vertical-default-link-active-color')
          }
        }
      }
    ]
  }) as unknown as EChartsOption;
  return (
    <Card className="mb-3" ref={cardRef}>
      <FalconCardHeader
        title={
          <div>
            رتبه و تعداد کلمات{' '}
            <HelpTooltip html={serpTooltips.domainRanksWords} />
          </div>
        }
        titleTag="h6"
        className="py-2"
        light
        endEl={<CardChartDropDown cardRef={cardRef} chartRef={chartRef} />}
      />
      <Card.Body className="px-3">
        {/* {formattedSeries.map(item => (
              <CustomLegent
                chartRef={chartRef}
                name={item.name}
                color={item.itemStyle.color}
                key={item.name}
              />
            ))} */}
        <ReactEChartsCore
          ref={chartRef}
          echarts={echarts}
          option={getOption()}
          style={{ height: '10rem' }}
        />
      </Card.Body>
    </Card>
  );
};
export default DomainRanksWords;
